import { render, staticRenderFns } from "./atcTaxCode.vue?vue&type=template&id=9704b656&"
import script from "./atcTaxCode.vue?vue&type=script&lang=ts&"
export * from "./atcTaxCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports